import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import Skeleton from "@material-ui/lab/Skeleton";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import { useRouter } from "next/router";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ImageViewerDialog(props) {
  const router = useRouter();

  const [loading, setloading] = useState(false);
  const [dialogImage, setdialogImage] = useState("");

  useEffect(() => {
    if (props.dialogState && props.imageUrl) {
      setloading(true);
      setdialogImage(`${props.imageUrl}`);
    }
  }, [props.dialogState, props.imageUrl]);

  const handleClose = () => {
    props.setdialogState(false);
  };

  const imageLoaded = () => {
    setloading(false);
  };

  return (
    <>
      <Dialog
        open={props.dialogState}
        TransitionComponent={Transition}
        fullScreen
        keepMounted
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            borderRadius: 20,
          },
        }}
        disableScrollLock={false}
        style={{ zIndex: 100 }}
        maxWidth="sm"
        onClose={handleClose}
      >
        <div>
          <div className="dialog-titlebar">
            <div className="dialog-close">
              <button
                className="bg-white text-black mt-16 mr-4 text-lg font-light h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
                type="button"
                onClick={handleClose}
              >
                <i className="fa fa-times"></i>
              </button>
            </div>
          </div>
          <div>
            <DialogContent>
              <div className="nft__image--fullscreen">
                <div>
                  {loading && (
                    <div
                      style={{
                        height: "700px",
                        maxHeight: "100vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div className="flex  	w-full my-6  mx-6" style={{flexDirection:"column"}}>
                      <Skeleton animation="wave" height={20} width="60%" />
                      <Skeleton animation="wave" height={20} width="60%" />
                      <Skeleton animation="wave" height={20} width="60%" />
                      </div>
                    </div>
                  )}
                  <img
                    key={Date.now()}
                    onLoad={imageLoaded}
                    onLoadStart={() => {
                      setloading(true);
                    }}
                    src={dialogImage ? dialogImage : ""}
                    style={{ display: loading ? "none" : "" }}
                    onError={(e) => {
                      e.target.onerror === null;
                      e.target.src = '/img/unknow.jpg';
                    }}
                    alt="owner image"
                  />
                </div>
              </div>
            </DialogContent>
          </div>
        </div>
      </Dialog>
    </>
  );
}
